import {Path, Svg} from 'react-native-svg';
import React from 'react';

const BigCheckIcon = React.forwardRef<any, any>((props, ref) => {
  return (
    <Svg ref={ref} width="55" height="55" viewBox="0 0 55 55" fill="none">
      <Path
        d="M27.5 55C42.5441 55 55 42.5172 55 27.5C55 12.4559 42.5172 0 27.473 0C12.4559 0 0 12.4559 0 27.5C0 42.5172 12.4828 55 27.5 55ZM27.5 50.4167C14.7745 50.4167 4.61029 40.2255 4.61029 27.5C4.61029 14.7745 14.7475 4.58333 27.473 4.58333C40.1985 4.58333 50.4167 14.7745 50.4167 27.5C50.4167 40.2255 40.2255 50.4167 27.5 50.4167ZM24.5343 40.3064C25.424 40.3064 26.1789 39.875 26.7181 39.0392L39.0392 19.6544C39.3358 19.1152 39.6863 18.5221 39.6863 17.9289C39.6863 16.7157 38.6078 15.9338 37.4755 15.9338C36.8015 15.9338 36.1275 16.3652 35.6152 17.1471L24.4265 35.1029L19.1152 28.2279C18.4681 27.3652 17.875 27.1495 17.1201 27.1495C15.9608 27.1495 15.0441 28.0931 15.0441 29.2794C15.0441 29.8725 15.2868 30.4387 15.6642 30.951L22.2426 39.0392C22.9167 39.9289 23.6446 40.3064 24.5343 40.3064Z"
        fill="white"
      />
    </Svg>
  );
});

BigCheckIcon.displayName = 'BigCheckIcon';

export default BigCheckIcon;
